import { useTranslation } from "react-i18next";

import { Invitation } from "simplydo/interfaces";

import { UserChip } from "components/lib/Chips";

const InviteeChip = ({
  invitation,
  youInvited,
  hasInvitedYou,
}: {
  invitation: Invitation;
  youInvited: string;
  hasInvitedYou: string;
}) => {
  const { t } = useTranslation();
  const { createdByCurrentUser, inviterUser } = invitation;

  if (createdByCurrentUser) {
    return (
      <span>
        {t("invitations.you")} {youInvited}
      </span>
    );
  }

  if (inviterUser) {
    return (
      <span>
        <UserChip compact="very" user={inviterUser} /> {hasInvitedYou}
      </span>
    );
  }

  return <span>{hasInvitedYou}</span>;
};

export default InviteeChip;
